// extracted by mini-css-extract-plugin
export default {"Panel":"n7IJVy7gVjESi_sh1OBN"};